module.exports = __webpack_public_path__ + "static/media/203_SHOT_094.d194bd95.webp";